import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractNavigationProperties.ts
 */
export class AbstractNavigationProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.balanceFieldProperties.equals(other.balanceFieldProperties) &&
            this.stakeProperties.equals(other.stakeProperties) &&
            this.totalStakeProperties.equals(other.totalStakeProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.NAVIGATION_BACKGROUND, SlingoStyle.MODULE);
        this.backgroundProperties.anchor.set(0.5, 0);
        this.balanceFieldProperties = new TextFieldProperties(FontStyle.BALANCE, null, null, ControlConstants.RIGHT, ControlConstants.CENTER);
        this.stakeProperties = new TextFieldProperties(FontStyle.BOTTOM_BAR, null, null, ControlConstants.LEFT, ControlConstants.CENTER);
        this.totalStakeProperties = new TextFieldProperties(FontStyle.BOTTOM_BAR, null, null, ControlConstants.LEFT, ControlConstants.CENTER);
        this.fieldOffset = 17;
        this.fullScreenOffset = 75;
    }
}
//# sourceMappingURL=AbstractNavigationProperties.js.map